// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"09525e9c","581":"96d2f89f","787":"a7297cdc"}[chunkId] + ".chunk.js";
};